'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PropTypesRegistry = require('./PropTypesRegistry');

var _PropTypesRegistry2 = _interopRequireDefault(_PropTypesRegistry);

var _index = require('./propTypes/index');

var customTypes = _interopRequireWildcard(_index);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _PropTypesRegistry2.default(_react2.default.PropTypes).registerAll(customTypes);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/react-utils/static-2.45/js/PropTypes.js
// module id = 103
// module chunks = 0